import { defineStore } from 'pinia';
import { isGrayUser } from '@tencent/wphk-components-gray-release';

export const useGrayStore = defineStore({
  id: 'gray',
  state: () => ({
    isGray: false,
  }),
  getters: {
    isGrayUser: (state) => state.isGray,
  },
  actions: {
    async init() {
      // // 开发时先禁用灰度
      // if (process.env.NODE_ENV === 'development') {
      //   this.isGray = true;
      //   return;
      // }
      // 竖状券灰度
      const isGray = await isGrayUser({ business: 'e-stamp', name: 'estamp-v3' });
      this.isGray = isGray;
    },
  },
});
